<script>
	import { navigate } from "svelte-routing";
	import {
		Button,
		Col,
		Row,
		Table,
		DropdownItem,
	} from "@sveltestrap/sveltestrap";
	import BsLoader from "../../../components/Loader/BsLoader.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import { convert } from "../../../services/helpers";
	import client from "../../../services/client";
	import { loadingStatus } from "../../../store/store";
	import { extractErrorMessage } from "src/utils/misc";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";
	export let carParkId;
	export let trigerFetch;
	export let dataLot = [];

	let loadStatus = false;
	let idStatus;
	const handleStatusChange = async (id, status) => {
		idStatus = id;
		try {
			loadingStatus.set(true);
			const update = await client(`/v1/carParks/lots/status`, {
				method: "PUT",
				version: "Vehicle",
				data: {
					id,
					status,
				},
			});
			trigerFetch();
			loadStatus = false;
		} catch (error) {
			loadStatus = false;
			loadingStatus.set(false);
			extractErrorMessage(error);
		}
	};
</script>

<Row class="my-3">
	<Col xs={6}>
		<PageHeader title="Parking lot" />
	</Col>
	<Col xs={6}>
		<Col class="d-flex justify-content-end me-4">
			<Row>
				<Col>
					<Button
						on:click={() =>
							navigate(
								`/carpark-management/details/add-lot/${carParkId}`
							)}
						class="themeButton primary">Add lot</Button
					>
				</Col>
			</Row>
		</Col>
	</Col>
</Row>
<Row class="my-3 ms-3">
	<Table responsive hover>
		<thead>
			<tr>
				<th>Parking lot number</th>
				<th>Level</th>
				<th>Date added</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each dataLot as { id, level, status, lotNumber, createdAt }}
				<tr>
					<td>{lotNumber}</td>
					<td>{level}</td>
					<td>{convert(createdAt)}</td>
					<td>
						{#if status}
							{#if $loadingStatus && idStatus == id}
								<p>&nbsp; &nbsp; <BsLoader /></p>
							{:else}
								<p class="status-bar status-bar-1 col-5">
									Active
								</p>
							{/if}
						{:else if $loadingStatus && idStatus == id}
							<p>&nbsp; &nbsp; <BsLoader /></p>
						{:else}
							<p class="status-bar status-bar-3 col-5">
								Inactive
							</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							{#if status}
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, false)}
									>Set as Inactive</DropdownItem
								>
							{:else}
								<DropdownItem
									on:click={() =>
										handleStatusChange(id, true)}
									>Set as Active</DropdownItem
								>
							{/if}
							<DropdownItem
								on:click={() =>
									navigate(
										`/carpark-management/details/edit-lot/${id}/${carParkId}`
									)}>Edit</DropdownItem
							>
						</TableDropdown>
					</td>
				</tr>
			{/each}
			{#if dataLot.length === 0}
				<tr>
					<td colspan="5" class="text-center">No data to display</td>
				</tr>
			{/if}
		</tbody>
	</Table>
</Row>

<style>
	:global(.table > :not(:first-child)) {
		border-top: 0;
	}
</style>
